import React, { useMemo, useState } from "react";
import { Form, Select } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { useQuery } from "@apollo/client";
import { GET_SUBCONTRACTOR_CURSOR } from "graphql/query/subcontractor-gql";
import { cursorPagination, Localize } from "components/service";
import { useDebounce } from "components/use-hooks";


const StaffAttendanceSubcontractorSelect = ({
    form,
    name = "subcontractor_id",
    selected = false,
    onChange = () => {},
}) => {
    const [ searchText, setSearchText ] = useState("");
    const debouncedSearchText = useDebounce(searchText);
    const searchSubcontractorLabel = Localize({
        children: "SEARCH.Input_Placeholder_Subcontractor",
    }).props.children;
    const { data, loading, fetchMore } = useQuery(GET_SUBCONTRACTOR_CURSOR, {
        variables: {
            text: debouncedSearchText,
            first: 25,
        },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
        notifyOnNetworkStatusChange: true,
    });
    const { nodes, onPopupScroll } = cursorPagination({
        model: "subcontractorsCursor",
        data,
        loading,
        fetchMore,
    });

    const options = useMemo(() => {
        const optionsByID = new Map();

        nodes.forEach((item) => {
            optionsByID.set(String(item.value), {
                value: String(item.value),
                label: item.label,
            });
        });

        return [
            {
                value: "all",
                label: <Localize>STAFF_MANAGEMENT.Filter_AllSubcontractors</Localize>,
            },
            ...optionsByID.values(),
        ];
    }, [ nodes ]);

    return (
        <Form.Item name={ name } noStyle>
            <Select
                allowClear
                aria-label={ searchSubcontractorLabel }
                clearIcon={ <CloseOutlined /> }
                showArrow
                showSearch
                className={ `staff-attendance-filter__subcontractor${
                    selected ? " staff-attendance-filter__subcontractor--chosen staff-filter-control--selected" : ""
                }` }
                dropdownClassName="staff-attendance-filter__subcontractor-dropdown"
                filterOption={ false }
                loading={ loading }
                options={ options }
                placeholder={ searchSubcontractorLabel }
                suffixIcon={ selected ? null : <SearchOutlined /> }
                onPopupScroll={ onPopupScroll }
                onSearch={ setSearchText }
                onChange={ (value) => {
                    const nextValue = value === "all" ? undefined : value;

                    form.setFieldsValue({ [ name ]: nextValue });
                    onChange(nextValue);
                } } />
        </Form.Item>
    );
};

export default StaffAttendanceSubcontractorSelect;
